import Commons from '../../Services/Common/Common';

export const M_ALA_BASIC_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid,
    },

    save1: {
      AsId: (context) =>
        Commons.EncryptAES(String(context.alarmSetting?.asId ?? '0')),
      AlarmGubun: (context) =>
        Commons.EncryptAES(context.alarmSetting.alarmGubun ?? ''),
      UseYn: (context) => Commons.EncryptAES(context.useYn ?? ''),
      UserId: (context) => context.userInfo?.userid,
    },
    save2: {
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
